import { Box, Container } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
// import { useForm } from "react-hook-form";
import { useParams, useNavigate } from 'react-router-dom'
import CustomButton from '../../../../../Components/CustomButton/CustomButton'
// import { Input } from "../../../../../Components/Input";
import { makeGetRequest, makePostRequest } from '../../../../../utils/api'
import urls from '../../../../../utils/urls'
import CreateOperationForm from './CreateOperationForm'
import ListOperations from './ListOperations'
// import ComboBox from '../../../../../Components/ComboBox'
import EditOperationForm from './EditOperationForm'
// import SupprimerOperationForm from './SupprimerOperationForm'

export const HistoriqueVHkm = () => {
  const { id } = useParams()
  const [operations, setOperations] = useState({})
  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selectedRows, setSelectedRows] = useState([])
  const [loading, setLoading] = useState(false)
  const [selected, setSelected] = useState(false)
  // const [selectedSupprimer, setSelectedSupprimer] = useState(false)

  useEffect(() => {
    fetchOperations()
  }, [])

  const fetchOperations = async (pagination = '') => {
    setLoading(true)
    let url = `${urls.crudVkhmOperations}`

    if (pagination !== '') {
      //general=true&
      url += pagination
    }
    const response = await makeGetRequest(url + '?IDvehicle=' + id, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }

  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteVkhmBulkOperations,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
      }
    }
  }

  return (
    <>
      <Container maxWidth="xl">
        <Box justifyContent="flex-end" padding={2} display="flex">
          <Box>
            <CreateOperationForm setOperations={setOperations} />
            <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  // formRef.current.handleClickOpen(true)
                  setSelectedRowsParams({
                    ...operations.results.filter((v) => v.id === selectedRows[0]),
                  })
                  setSelected(true)
                } else {
                  setSelected(false)
                  alert('Please Select one document for modifier')
                }
              }}
            >
              Modifier
            </CustomButton>
            {selected ? (
              <EditOperationForm
                setOperations={setOperations}
                setSelected={setSelected}
                params={selectedRowsParams}
                operations={operations}
              />
            ) : (
              ''
            )}
            {/* supprimer */}
            {/* <CustomButton
              onClick={() => {
                if (selectedRows.length === 1) {
                  // formRef.current.handleClickOpen(true)
                  setSelectedRowsParams({...operations.results.filter((v) => v.id === selectedRows[0])})
                  // setSelectedSupprimer(true)
                 
                } else {
                  // setSelectedSupprimer(false)
                  alert('Please Select one document for supprimer')
                }
              }}
            >
              supprimer
            </CustomButton> */}
            {/* {selectedSupprimer ? (

              <SupprimerOperationForm
                      setOperations={setOperations}
                      setSelected={setSelected}
                      params={selectedRowsParams}
                      operations={operations}
                      
                    />
            ):(
              ''
            )} */}

            <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
          </Box>
        </Box>

        <ListOperations
          fetchOperations={fetchOperations}
          setSelectedRows={setSelectedRows}
          operations={operations}
        />
      </Container>
    </>
  )
}
